<template>
  <section>
    <div class="german">
      <h1>Teilnahmebedingungen</h1>
      <p>
        Liebe Teilnehmerin und lieber Teilnehmer,
        <br />Sie interessieren sich dafür, eine web-basierte Schreibtherapie zu machen. Diese wird
        im Rahmen einer wissenschaftlichen Studie durchgeführt, die die Wirksamkeit eines
        web-basierten Programmes zur Behandlung von psychischen Beschwerden untersucht. Wir bieten
        spezifische Therapien zur Behandlung der posttraumatischen Belastungsstörung, zur Behandlung
        von depressiven Beschwerden sowie zur Behandlung allgemeiner leichterer psychischer
        Belastungen an. Wir möchten Sie vorher ausführlich über die Studie inforieren.
      </p>
      <p>
        <strong>Unser Behandlungsangebot</strong>
      </p>
      <p>
        Für die Behandlung der psychischen Beschwerden führen wir verschiedene Therapien online
        durch. Die Therapien dauern insgesamt ungefähr zwischen 3 und 6 Wochen und sind im Ablauf
        ähnlich, unterscheiden sich jedoch in ihrem inhaltlichen Schwerpunkt. Die Zuteilung zu einer
        der Therapien erfolgt abhängig von Ihren Beschwerden nach einem fernmündlichen Gespräch mit
        einem unserer Mitarbeiter oder einer unserer Mitarbeiterinnen. Die Zuteilung zu einer
        spezifischen Therapieform zur Behandlung der posttraumatischen Belastungsstörung bzw. der
        depressiven Beschwerden erfolgt nach wissenschaftlichen Regeln zufällig. Die Kommunikation
        zwischen Ihnen und Ihrem persönlichen Therapeuten oder Ihrer persönlichen Therapeutin findet
        dabei ausschließlich über das Internet statt. Die Behandlungen sind nach einem
        wissenschaftlich überprüften Ablauf aufgebaut. Dieser besteht aus festgelegten
        Schreibaufgaben. Er kann sich aber der persönlichen Situation und den Möglichkeiten des
        Patienten oder der Patientin anpassen. Im Rahmen beider Therapien werden Sie wöchentlich
        Briefe verfassen. Die Briefe werden an bestimmten Terminen geschrieben, die Sie zu Beginn
        jeder Phase festlegen. Ihre Termine sind mit Therapiesitzungen zu vergleichen und die
        Einhaltung daher von großer Wichtigkeit, da Ihr Therapeut oder Ihre Therapeutin nach jedem
        zuvor festgelegten Termin auf ihren Brief wartet, um darauf zu antworten. Das Verfassen der
        Briefe basiert auf speziellen Anweisungen, welche Ihnen Ihr Therapeut oder ihre Therapeutin
        vorher zukommen lässt. Ihr Therapeut oder Ihre Therapeutin verpflichtet sich, Ihnen nach
        Ablauf von ca. zwei Werktagen auf Ihre Briefe zu antworten und im Gegenzug erwarten wir von
        Ihnen die Einhaltung der Termine, die Sie festlegen werden. Es kann passieren, dass es bei
        Ihnen zu Beginn der Therapie zunächst zu dem Gefühl der Verschlechterung der psychischen
        Verfassung kommt. Insbesondere in der Therapie zur Behandlung der posttraumatischen
        Belastungsstörung findet eine Auseinandersetzung mit Ihrem traumatischen Erlebnis statt. Es
        kann vorkommen, dass dabei Details des Traumas zurück in das Gedächtnis gerufen werden. Eine
        vorläufige Verschlechterung ist jedoch ein natürlicher Vorgang, der Ihnen keine Angst zu
        machen braucht, da dieser Schritt therapeutisch von einem unserer Therapeuten oder
        Therapeutinnen begleitet wird. Ihr Therapeut oder Ihre Therapeutin wird Ihnen während der
        gesamten Therapie zur Seite stehen und Sie motivieren mit der Therapie fortzufahren.
      </p>
      <p>
        <strong>Ziel der Studie</strong>
      </p>
      <p>
        Die Studie zur Evaluation der Behandlung wird vom Zentrum ÜBERLEBEN in enger Kooperation mit
        der Freien Universität Berlin durchgeführt. Die wissenschaftliche Leitung liegt bei Dr. Maya
        Böhm, Dr. Yuriy Nesterko und Prof. Dr. Maria Böttche. Mithilfe der Studie soll die
        Wirksamkeit der Onlinebehandlungen untersucht werden. Die Wirksamkeit der Behandlungen wird
        dabei anhand der Verringerung der psychischen Beschwerden in der jeweiligen Therapie (z.B.
        Verringerung der depressiven Symptomatik und Verringerung der posttraumatischen
        Belastungssymptomatik) beurteilt. Ferner wird zum Beispiel die allgemeine Lebensqualität,
        die physische Gesundheit sowie Trauma- und Verlusterfahrungen erfasst. Ziel dieser Studie
        ist es darüber hinaus, die Akzeptanz und praktische Anwendung der Therapien im arabischen
        Sprachraum zu untersuchen. Auch wollen wir ein genaueres Bild über die Auswirkungen von
        belastenden Lebensereignissen bei arabischsprachigen Teilnehmern erhalten.
      </p>
      <p>
        <strong>Freiwilligkeit der Teilnahme</strong>
      </p>
      <p>
        Die Teilnahme an dieser Behandlung ist freiwillig und im Rahmen der Studie kostenfrei. Wenn
        Sie auf die Teilnahme an dieser Studie verzichten, haben Sie keine Nachteile zu erwarten.
        Dies gilt auch, wenn Sie Ihre dazu gegebene Einwilligung zu einem späteren Zeitpunkt
        widerrufen. Sie können die Behandlung zudem jederzeit ohne Angabe von Gründen abbrechen, die
        bis dahin erhobenen Daten werden anonym weiterverwendet. Eine Löschung dieser kann beantragt
        werden. Hierzu schicken Sie uns bitte eine Mail an support-ilajnafsy@ueberleben.org.
      </p>
      <p>
        <strong>Studienverlauf</strong>
      </p>
      <p>
        Alle Teilnehmer und Teilnehmerinnen müssen zunächst im Onlineportal Ihr allgemeines
        Einverständnis geben, um sicher zu stellen, dass alle Informationen zur Behandlung und zur
        Studie sowie zum Datenschutz verstanden worden sind. Ohne diese Einverständniserklärung kann
        nicht mit der Diagnostik und der Behandlung begonnen werden. Nach der
        Einverständniserklärung bitten wir Sie eine Reihe von Fragebögen auszufüllen. Diese
        Fragebögen enthalten verschiedene Fragen zu Ihrem psychischen Wohlbefinden, einschließlich
        Fragen zu traumatischen Ereignissen, die Sie möglicherweise erlebt haben, sowie Fragen zu
        suizidalen Gedanken oder Absichten. Anhand dieser Fragebögen findet eine erste Einschätzung
        statt, ob die web-basierte Behandlung derzeit eine geeignete Behandlungsmethode für Sie
        darstellt. Sollte dies der Fall sein, so können Sie direkt im Anschluss ein diagnostisches
        Interview buchen. Im Interview werden Ihre Symptome nochmal genauer erfragt. Sollte die
        Behandlung nicht für Sie geeignet sein, so werden wir Sie, nach Möglichkeit, zu alternativen
        Behandlungsangeboten beraten. Teilnehmer und Teilnehmerinnen werden nach der Überprüfung
        durch die Fragebögen und das Interview bei entsprechender Eignung zu einer der von uns
        angebotenen Behandlungen (abhängig von den jeweiligen Beschwerden) zugeteilt. Im Anschluss
        erfolgt für Personen mit einer depressiven Störung eine zufällige Zuteilung zu einer von
        zwei Behandlungsformen (kognitiv-verhaltenstherapeutische Behandlung oder interpersonelle
        Psychotherapie). Die Behandlungen sind im Ablauf identisch, haben jedoch unterschiedliche
        Behandlungsschwerpunkte. Für Personen mit einer posttraumatischen Belastungsstörung erfolgt
        eine zufällige Zuteilung zu einer von zwei Behandlungsformen (Expositionsbehandlung oder
        kognitive Behandlung). Auch hier sind die Behandlungen im Ablauf identisch, haben jedoch
        unterschiedliche Behandlungsschwerpunkte. Im Rahmen eines wissenschaftlichen Arbeitens (wie
        im Rahmen dieser Studie) erfolgt die Zuteilung zu einer der Therapien per Zufallsverfahren.
        Nach der Behandlung sowie drei und sechs Monate später werden wir Sie erneut bitten einige
        Fragebögen auszufüllen. Auch werden Sie im Verlauf der Therapie gebeten, einige Fragen zu
        beantworten, die sich auf den Therapieverlauf und Ihre Symptome beziehen. Die anonym
        ausgewerteten Antworten werden verglichen und statistisch analysiert, um so die Wirksamkeit
        dieser Behandlung feststellen zu können. Außerdem wird erfragt, wie Sie persönlich die
        Behandlung und die Tatsache, dass diese über das Internet stattfand, empfunden haben.
        Gegebenenfalls werden Sie von uns im Anschluss an die Therapie für ein fernmündliches
        Feedback-Gespräch eingeladen. Die Teilnahme ist freiwillig.
      </p>
      <p>
        <strong>Ein- und Ausschlusskriterien</strong>
      </p>
      <p>
        Anhand von Fragebögen und einem Gespräch wird untersucht, ob die Behandlungen derzeit eine
        geeignete Behandlungsmöglichkeit für Sie darstellt. Ein Mindestalter von 18 Jahren ist
        Voraussetzung für die Therapieteilnahme. Die Teilnahme ist nicht möglich, wenn eine
        intensivere, medizinische bzw. psychologische Unterstützung (beispielsweise aufgrund von
        Suizidalität, Fremdgefährdung, einer sehr schweren Symptomatik,
        Alkohol-/Drogen-/Substanzabhängigkeit, psychotisches Erleben) benötigt wird. Auch sollte
        nicht zeitgleich eine andere psychotherapeutische oder psychiatrische Behandlung der
        Beschwerden erfolgen. Zudem sollten für die gesamte Behandlungsdauer eine gültige,
        persönliche E-Mail-Adresse und eine ausreichende Internetverbindung verfügbar sein.
      </p>
      <p>
        <strong>Alternative Behandlungsmethoden</strong>
      </p>
      <p>
        Neben der web-basierten Behandlung, die wir anbieten, gibt es noch eine Reihe anderer
        Alternativen zur Behandlung psychischer Beschwerden. Es bestehen beispielsweise
        Behandlungsansätze, bei denen der Therapeut oder die Therapeutin anhand von Gesprächen
        versucht, den Patienten und Patientinnen zu helfen und diese zu unterstützen. Es gibt
        außerdem Behandlungen, bei denen es in Gesprächen vor allem um die Vermittlung von neuen
        Perspektiven geht. Es ist uns dabei wichtig, deutlich zu machen, dass Sie sich auch für
        Behandlungsformen entscheiden können, in denen der persönliche Kontakt eine spezifischere
        und zentralere Rolle einnimmt. In manchen Fällen werden wir Ihnen sogar raten sich eher für
        eine Behandlungsform zu entscheiden, bei der Sie direkten Kontakt mit Ihrem Therapeuten oder
        Ihrer Therapeutin haben. Eine psychopharmakologische Behandlung kann zudem bei einigen
        Beschwerden ebenfalls indiziert sein.
      </p>
      <p>
        <strong>Pflichten des Studienteilnehmers</strong>
      </p>
      <p>Als Studienteilnehmer oder Studienteilnehmerin sind Sie verpflichtet,</p>
      <ul>
        <li>
          den Anweisungen des Programms oder der Therapeuten und Therapeutinnen zu folgen und sich
          an den Behandlungsplan zu halten
        </li>
        <li>
          den Therapeuten oder die Therapeutin genau über den Verlauf der Erkrankung und
          festgestellte, unerwünschte Wirkungen der Therapie zu informieren. Dazu gehört auch das
          Auftreten suizidaler Gedanken
        </li>
        <li>
          den Therapeuten oder die Therapeutin über die gleichzeitige Behandlung bei einem anderen
          Arzt/Therapeuten oder die Einnahme von Arzneimitteln aufzuklären
        </li>
      </ul>

      <p>
        <strong>Nutzen und Aufwand für die Teilnehmer</strong>
      </p>
      <p>
        Die Studien- und Behandlungsteilnahme ist mit einem gewissen Aufwand verbunden. So sollten
        Sie über einen Zeitraum von drei bis sechs Wochen wöchentlich etwa zwei Mal die Möglichkeit
        haben, sich intensiv mit den Inhalten des Behandlungsprogramms zu beschäftigen. Darüber
        hinaus ist zu beachten, dass es während der Therapie vorübergehend zu
        Stimmungsverschlechterung kommen kann. Es besteht allerdings jederzeit die Möglichkeit,
        Kontakt zu ihrem Therapeuten oder ihrer Therapeutin aufzunehmen. Demgegenüber ist die
        Studienteilnahme jedoch auch mit einem voraussichtlichen Nutzen verbunden. In vergleichbaren
        web-basierten Studien konnten sehr gute Ergebnisse in der Reduktion der psychischen Symptome
        erzielt werden.
      </p>
      <p>
        <strong>Vertraulichkeit der Daten</strong>
      </p>
      <p>
        Im Rahmen dieser Studie werden persönliche Daten von Ihnen erfasst, welche jedoch nur
        Fachleuten zur wissenschaftlichen Auswertung zugänglich sind. Allerdings wird auch hierbei
        die Vertraulichkeit strikt gewahrt und Ihr Name wird in keiner Weise in Publikationen oder
        Berichten, die aus der Studie hervorgehen, veröffentlicht. Alle an der Behandlung
        beteiligten Personen unterliegen zudem der Schweigepflicht. Dies bedeutet, dass alle
        ausgetauschten Informationen streng vertraulich behandelt werden. Die Antworten der
        Fragebögen werden nicht anhand von Namen, sondern lediglich anhand von Nummern gespeichert,
        so dass die Herkunft nicht nachvollziehbar ist.
      </p>

      <p>
        <strong>Kosten</strong>
      </p>
      <p>
        Behandlung ist für eine begrenzte Anzahl von Teilnehmern und Teilnehmerinnen im Rahmen der
        Studie kostenfrei.
      </p>
      <p>
        <strong>Entschädigung</strong>
      </p>
      <p>Für die Teilnahme an dieser Studie erhalten Sie keine Entschädigung.</p>
      <p>
        <strong>Unfreiwilliger Studienabbruch</strong>
      </p>
      <p>
        Teilnahme kann durch die Studienleitung oder -koordination abgebrochen werden. Die
        Behandlung wird vorzeitig beendet, wenn:
      </p>
      <ul>
        <li>sich herausstellt, dass Ein- und Ausschlusskriterien verletzt wurden</li>
        <li>
          eine akute Krise auftritt (z.B. akute Suizidalität) und eine intensivere Behandlung
          angemessen scheint
        </li>
        <li>
          wenn sich die Teilnehmer oder Teilnehmerinnen mehrfach nicht an Termine oder
          Behandlungsvereinbarungen halten
        </li>
      </ul>

      <p>
        <strong>Zusätzliche wichtige Informationen</strong>
      </p>
      <p></p>
      <ul>
        <li>
          <u>Supervision:</u> Alle Therapeuten und Therapeutinnen werden regelmäßig supervidiert.
          Dies bedeutet, dass die Mitarbeitenden, die die Therapien durchführen, von erfahrenen
          Therapeuten und Therapeutinnen unterstützt werden, wenn Schwierigkeiten in der Behandlung
          auftreten. Der für Sie zuständige Supervisor oder die für Sie zuständige Supervisorin hat
          Einblick in Ihre Behandlungsdaten.
        </li>
        <li>
          <u>Terminvereinbarung während der Behandlung:</u> Wie bereits erwähnt werden Sie Ihre
          Briefe zu bestimmten Terminen schreiben. Sollte es mal vorkommen, dass Sie sich aufgrund
          eines Notfalls nicht an einen Termin halten können, so bitten wir Sie dies rechtzeitig
          Ihrem Therapeuten oder ihrer Therapeutin mitzuteilen. Die Einhaltung der Termine hat sich
          im Rahmen verschiedener wissenschaftlicher Untersuchungen als eines der wichtigsten
          Kriterien für die Wirksamkeit der Therapie erwiesen. Bitte gehen Sie sicher, dass Sie die
          von Ihnen gewählten Termine einhalten können, bevor Sie diese festlegen, da bei
          wiederholtem Nichteinhalten der Termine und bei unangekündigtem Untertauchen für längere
          Phasen, eine Frist gesetzt wird, innerhalb derer von Ihnen eine Antwort gefordert wird.
          Bleibt diese Antwort aus, wird die Therapie nach Ablauf der gesetzten Frist vorzeitig
          beendet und Sie aus dem Therapieprogramm ausgeschlossen.
        </li>
        <li>
          <u>Notfälle:</u> In Notfällen, etwa wenn der Kontakt zu Ihnen unangekündigt unterbrochen
          wird, wird Ihr Therapeut oder Ihre Therapeutin sich telefonisch bei Ihnen melden. Wir
          bitten Sie, persönlich das Telefonat entgegenzunehmen und die Richtigkeit Ihrer
          angegebenen Nummer zu überprüfen sowie diese im Falle einer Änderung zu aktualisieren.
          Zudem werden wir Sie zu Beginn der Behandlung bitten einen Notfallkontakt anzugeben, damit
          wir im Notfall eine Ihnen nahestehende Person erreichen können.
        </li>
      </ul>
      <p>
        Informationen zu dem Beratungsangebot von Ilajnafsy finden Sie
        <a :href="url" target="_blank" rel="noopener noreferrer">hier</a>
      </p>
    </div>
    <div class="arabic">
      <h1>معلومات المشاركة</h1>
      <p>
        عزيزي المشارك / عزيزتي المشاركة ،
        <br />نشكركم على اهتمامكم في التسجيل في برنامج علاج نفسي عن طريق الانترنت القائم على العلاج
        الكتابي.هذا البرنامج يتم تقديمه ضمن اطار دراسة علمية هدفها اثبات فعالية العلاج الكتابي عن
        طريق الانترنت لمعالجة الاضطرابات النفسية. نحن نقدم علاجات متخصصة لعلاج اضطراب ما بعد الصدمة
        النفسية ولعلاج الاكتئاب مثلما ايضاً لعلاج الضغوط النفسية العامة والخفيفة. لهذا نود اولا
        تعريفكم على هذه الدراسة العلمية بشكل تفصيلي.
      </p>
      <p>
        <strong>برنامجنا للعلاج النفسي</strong>
      </p>
      <p>
        برنامج علاج نفسي يقدم علاجات مختلفة عبر الإنترنت لعلاج الاضطرابات النفسية. عموماً يستغرق
        العلاج بين 3 الى 6 أسابيع وتتشابه العلاجات من حيث المبدأ ومسار العلاج ولكن تختلف من حيث
        المحتوى. يعتمد التوزيع على أحد أنواع العلاجات على الأعراض التي تواجهها والتي يتم التعرف
        عليها من خلال إجراء مقابلة صوتية مع أحد الأخصائيين في البرنامج. يتم التوزيع على أحد أنواع
        العلاجات المخصصة لعلاج اضطراب ما بعد الصدمة أو الاكتئاب بشكل عشوائي وذلك لأغراض البحث العلمي
        . التواصل بينك وبين المعالجـ/ـة الخاص بك تتم بشكل أساسي وحصري عبر الانترنت . تم تصميم
        العلاجات وفق مسار علمي مدروس وتتألف من مهمات كتابية ثابتة ولكنها من الممكن ان تتكيف مع الوضع
        الخاص وامكانيات المتعالج الشخصية. التواصل العلاجي مبني على اساس كتابة نصوص على شكل رسائل.
        تتم كتابة هذه الرسائل في مواعيد معينة, قد تم تحديدها مسبقاً من قبل المتعالج ذاته في بداية
        المرحلة العلاجية.المواعيد المتفق عليها مسبقا هي بمثابة جلسات العلاج وبالتالي من الاهمية
        بمكان الالتزام بها لان المعالج او المعالجة يقوم بانتظار الرسالة في الموعد المحدد لها ليقوم
        بدوره بالرد عليها. كتابة هذه الرسائل يتم على اساس ارشادات معينة يرسلها لك المعالج قبل الشروع
        بالكتابة. يتعهد المعالج بالرد على الرسالة بعد يومي عمل وفي المقابل نتوقع منكم الحفاظ على
        المواعيد التي قمتم بتحديدها مسبقا.
        <br />قد يواجهك الشعور بتدهور حالتك النفسية بعد البدء بالعلاج وخاصة في علاج اضطراب الشدة ما
        بعد الصدمة النفسية حيث تتم مناقشة تجربتك الصادمة ويمكن أن يحدث أن يتم تذكر تفاصيل الصدمة .
        ومع ذلك ، فإن هذا التدهور الأولي هو عملية طبيعية لا تحتاج إلى الشعور بالخوف ، لأن هذه الخطوة
        ستكون مصحوبة علاجياً من أحد المعالجين في البرنامج. سيكون المعالج الخاص بك إلى جانبك طوال
        الوقت خلال فترة العلاج وسيحفزك على مواصلة العلاج.
      </p>
      <p>
        <strong>الهدف من الدراسة العلمية</strong>
      </p>
      <p>
        تجري هذه الدراسة العلمية لتقييم العلاج تحت اشراف البروفسورة الدكتورة كريستينا كنيفلسرود
        والدكتورة بيرجيت فاغنر والدكتورة ماريا بوتشه من قبل مركز ( أوبرليبن ) في برلين . بمساعدة هذه
        الدراسة سوف يجري تقييم فعالية العلاج عبر الانترنت. يتم اعتبار ان العلاج فعال اذا تم تخفيص
        شدة الأعراض النفسية في العلاج الذي يخضع له الشخص ( مثلاً: تخفيض الأعراض الاكتئابية وأعراض
        اضطراب الشدة ما بعد الصدمة النفسية). ومن ناحية اخرى وعلى سبيل المثال يتم الحصول على تقييم
        نوعية الحياة عموماً والصحة النفسية والصدمات النفسية وخبرات فقدان الأشخاص. وهدف هذه الدراسة
        العلمية ايضا اختبار تقبل العلاج في البلدان العربية. من ناحية اخرى نريد من خلال هذه الدراسة
        الحصول على صورة متكاملة عن التداعيات النفسية وتأثيرها لدى المتعالجين في الوطن العربي.
      </p>
      <p>
        <strong>الاشتراك الطوعي</strong>
      </p>
      <p>
        يعتبر الاشتراك في برنامج العلاج في إطار الدراسة التي نجريها طوعي ومجاني. اذا اردت الامتناع
        عن المشاركة في البرنامج فلن يترتب عليك اي سلبيات. وينطبق ذلك ايضا اذا قررت فيما بعد سحب
        موافقتك التي قمت بارسالها لنا مسبقا. يمكنك الغاء الاشتراك في العلاج في اي وقت ومن دون ذكر اي
        اسباب. وعلى هذا الاساس يتم استخدام بيانات الاستبيانات التي قمت بملئها في الدراسة مسبقا بشكل
        مشفر ومحمي. يمكنك طلب حذف بياناتك بالكامل وذلك من خلال ارسال ايميل الى عنوان البريد
        الالكتروني التالي: support-ilajnafsy@ueberleben.org.
      </p>
      <p>
        <strong>مسار الدراسة العلمية</strong>
      </p>
      <p>
        يحتاج جميع المشاركين والمشاركات توقيع موافقة عامة في بوابة الموقع الالكترونية للتاكد بان
        المشترك قد فهم جميع المعلومات المتعلقة بالعلاج والدراسة العلمية. من دون هذه الموافقة العامة
        لا يمكننا البدأ بمرحلة التشخيص والعلاج. تتضمن هذه الاستبيانات أسئلة متنوعة حول صحتك النفسية،
        من ضمنها أسئلة حول الحدث أو الأحداث الصادمة التي قد تكون تعرضت لها ، بالإضافة الى أسئلة عن
        الأفكار أو النوايا الانتحارية. نطلب منك ملء سلسلة من الاستبيانات بعد التوقيع على الموافقة
        العامة. على اساس هذه الاستبيانات سوف نتمكن من الحصول على انطباع اولي فيما لو كان برنامجنا
        للعلاج النفسي عن الطريق الانترنت مناسب لحالتك. في حال كان البرنامج مناسبا لك سوف تتاح لك
        تتاح لك الفرصة لحجز مقابلة تشخيصية. اثناء هذه المقابلة سوف يتم سؤالك مجدداً و بشكل دقيق عن
        الأعراض التي تعاني منها. واذا اتضح من خلال المقابلة بان العلاج ليس مناسب لك ،عندها سوف يتم
        ارشادك الى بدائل علاجية اخرى. يتم توزيع المشاركين والمشاركات في البرنامج بعد التدقيق في
        المقابلة التشخيصية والاستبيانات على العلاج المناسب من العلاجات التي نقدمها. بعد ذلك، يتم
        تعيين الأشخاص الذين يعانون من اضطراب الاكتئاب بشكل عشوائي على واحد من نوعين من العلاج
        (العلاج المعرفي السلوكي أو العلاج النفسي البينشخصي). العلاجين متطابقين من حيث المسار ولكن
        مختلفين من حيث نقاط التركيز. يتم تعيين الأشخاص الذين يعانون من اضطراب ما بعد الصدمة النفسية
        بشكل عشوائي على واحد من نوعين من العلاج (علاج المواجهة أو العلاج المعرفي) وهنا يكون العلاجين
        ايضاً متطابقين من حيث المسار ومختلفين من حيث نقاط التركيز العلاجية. في إطار العمل العلمي
        (كما في هذه الدراسة) يتم التوزيع على أنواع العلاج بشكل عشوائي. بعد العلاج وأيضاً بعد ثلاثة
        وستة أشهر لاحقاً سيتم طلب ملء الاستبيانات مجدداً. كذلك أثناء العلاج سيتم الطلب منك للإجابة
        على بعض الأسئلة التي تخص مسار العلاج والاعراض التي تعاني منها. سيتم مقارنة وتحليل الإجابات
        على الأسئلة احصائياً حتى يتسنى لنا معرفة فعالية العلاج الذي نقدمه. كما سنطلب منكم رايكم
        الشخصي فيما يتعلق بمسار العلاج، وحقيقة أن هذا العلاج جرى عن طريق الانترنت فقط.
      </p>
      <p>
        <strong>معايير الإنتقاء والإقصاء</strong>
      </p>
      <p>
        يتم التأكد فيما لو العلاج النفسي في برنامجنا هو الخيار المناسب لك وذلك على ضوء نتائج
        الاستبيانات والمقابلة التشخيصية. الحد الادنى من العمر للإستطاعة بالمشاركة في العلاج هو 18
        سنة. المشاركة في العلاج عن طريق برنامجنا غير ممكنة ايضا في حال اكتشاف بان حالتك بحاجة الى
        دعم نفسي وطبي مكثف( مثلاً في حال وجود خطر الانتحار,او إيذاء الغير، الادمان على الكحول
        أوالمخدرات, او توفر عوارض نفسية ذو حدة عالية اوالمعاناة من مرض الذهان بشتى انواعه). من
        معايير الاقصاء ايضا هو تلقيك علاج نفسي او طبي نفسي من جهة اخرى بشكل موازي. من المهم ايضا
        توفر عنوان بريد الكتروني صالح وفرصة اتصال بالانترنت طوال فترة العلاج.
      </p>
      <p>
        <strong>العلاجات البديلة</strong>
      </p>
      <p>
        يوجد العديد من العلاجات النفسية البديلة فضلا عن العلاج الذي نقدمه عن طريق الانترنت وذلك بما
        يخص علاج الاضطرابات النفسية . فمن ضمن هذه العلاجات البديلة يقوم الاخصائي النفسي بالتكلم خلال
        الجلسات مع المريض ويقدم له الدعم المعنوي والنفسي. وفي انواع اخرى يقوم الاخصائي النفسي
        بمساعدة المريض على ايجاد افق جديدة. وهنا نود ان نقوم بايضاح بان للمريض امكانية اختيار علاج
        مناسب يكون مبني على علاقة محورية وخاصة مع المعالج النفسي. في بعض الحالات ممكن ان ننصح بطريقة
        علاجية يكون فيها التواصل المباشر اي وجه لوجه مع الاخصائي النفسي نواة العلاج .
      </p>
      <p>
        <strong>التزامات المشترك في الدارسة العلمية</strong>
      </p>
      <p>على كل المشتركين في البرنامج ان يكونوا ملتزمين بالنقاط التالية:</p>
      <ul>
        <li>الالتزام بتعليمات البرنامج والمعالجين النفسيين والمحافظة على مسار العلاج.</li>
        <li>
          إخبار المعالج المختص في حال طرأت عوارض غير مرغوب فيها اثناء العلاج وخاصة عند ظهور افكار
          انتحارية عند المتعالج.
        </li>
        <li>
          إخبار المعالج المختص في حال وجود علاج نفسي موازي عند اخصائي اخر او تناول اي ادوية نفسية
          اثناء فترة العلاج.
        </li>
      </ul>

      <p>
        <strong>فوائد واعباء المشاركين في البرنامج</strong>
      </p>
      <p>
        ترتبط المشاركة في هذه الدراسة والعلاج ببعض الاعباء والجهد. يُلزِم المشترك نفسه بالتعاطي بشكل
        مكثف مع محتويات العلاج والبرنامج مرتين اسبوعياً وذلك لمدة ثلاثة اسابيع متتالية الى ستة
        أسابيع. علاوة على ذلك يجب علينا التنويه بانه ممكن ان يحدث اثناء فترة العلاج تدهور في مزاج
        المتعالج. غير اننا نود ان نؤكد ايضا بان هناك امكانية دائمة للتواصل مع المعالج او المعالجة في
        مثل هذه الحالات. في المقابل يقدم برنامجنا للمشتركين فائدة متوقعة وكبيرة حيث اثبتت الدراسات
        ومقارنة مع اساليب علاج اخرى عن طريق الانترنت، بأن من خلال هذا البرنامج يطرأ تحسن ملموس ومثبت
        علمياً بما يخص الأعراض بعد انتهاء العلاج.
      </p>
      <p>
        <strong>سرية البيانات</strong>
      </p>
      <p>
        يتم اثناء هذه الدراسة العلمية تسجيل البيانات الخاصة بالمشترك ليتم عرضها على العلماء المختصين
        في هذا البحث والبرنامج ليقوموا بتقييمها واعدادها بشكل علمي. ويتم ذاك حصراً مع احترام سرية
        المعلومات بشكل فائق حيث من المحال ان يظهر اسم اي مشترك بأي حال من الأحوال في المنشورات أو
        التقارير العلمية التي تخرج عن هذا البحث العلمي. جميع الأشخاص المشاركين في العلاج والدراسة
        ملتزمين بالتعاطي بتكتم كامل بما يخص كافة المعلومات. هذا يعني بان جميع المعلومات المتبادلة
        تخضع لسرية تامة. لا يتم حفظ اي اجوبة في الاستبيانات تحت اسم او لقب المشترك، بل نقوم بتشفيرها
        بشكل رقمي حيث يصبح من المستحيل معرفة منشأها.
      </p>

      <p>
        <strong>التكاليف</strong>
      </p>
      <p>العلاج يكون مجاني بالكامل لعدد محدود من المشاركين والمشاركات في الدراسة العلمية.</p>
      <p>
        <strong>التعويض</strong>
      </p>
      <p>لا يوجد اي تعويضات او فوائد مادية تتعلق بالمشاركة في هذه الدراسة العلمية.</p>
      <p>
        <strong>الانقطاع اللاإردي عن المشاركة في الدارسة العلمية</strong>
      </p>
      <p>
        ممكن ايقاف مشاركتك في الدراسة العلمية من خلال القائمين عليها، اي يمكن ايقاف العلاج قبل أوانه
        في حال:
      </p>
      <ul>
        <li>اكتشاف بانه تم الإخلال بمعايير الإقصاء والإنتقاء.</li>
        <li>
          او حدوث ازمة حادة تظهر من خلالها معطيات تدل مثلا على افكار او محاولات انتحارية آنية مما
          يتطلب رعاية نفسية مشددة لا تتوفر في برنامجنا.
        </li>
        <li>
          ايضا في حال لم يحافظ المشترك بشكل متكررعلى اتفاقية العلاج والمواعيد العلاجية المبرمة.
        </li>
      </ul>

      <p>
        <strong>معلومات اضافية هامة</strong>
      </p>
      <p></p>
      <ul>
        <li>
          <u>جلسات الإشراف:</u> يخضع جميع المعالجين والمعالجات في البرنامج لجلسات إشراف بشكل منتظم
          من قبل معالجين مشرفين متخصصين وذلك لدعم المعالجين في برنامجنا في حال وجود صعوبات في
          العلاج. المعالج المشرف يكون لديه اطلاع على بيانات علاجك.
        </li>
        <li>
          <u>تحديد مواعيد الجلسات اثناء العلاج:</u> كما تم التنوية اليه سابقاً يتم كتابة الرسائل
          العلاجية وفق مواعيد تم ابرامها من قبل المتعالج ذاته. في حال حدثت ظروف طارئة منعت المشترك
          من كتابة الرسالة في الموعد المتفق عليه، يجب هنا على المشترك اخبار المعالج المختص بذلك في
          الوقت المناسب. لقد اثتبت الدراسات العلمية ان الامتثال للمواعيد المبرمة يشكل عاملاً اساسياً
          في نجاح العلاج وله تاثير ايجابي على العملية العلاجية ككل. الرجاء التاكد بأنه بامكانك
          الحفاظ على المواعيد التي سوف تبرمها بنفسك قبل تحديدها. في حال عدم الالتزام بالمواعيد
          والاختفاء من دون سابق انذار لمدة طويلة نسبيا سوف نقوم بوضع موعد نهائي يجب على المشترك ان
          يعطي جواب اثنائه, واذا لم نحصل قبل الموعد النهائي على اي رد, نقوم بانهاء العلاج بشكل فوري
          والاقصاء من البرنامج.
        </li>
        <li>
          <u>حالات الطوارئ:</u> في حالات الطوارئ او مثلا عندما ينقطع تواصلكم مع العلاج من دون سابق
          انذار يقوم عندها المعالج بالاتصال بكم هاتفياً. نطلب منكم في هذا الحال الرد شخصياً على
          الهاتف والتأكد من صحة رقم الهاتف وتحديثه في حال طرأ عليه اي تغيير. إضافة الى ذلك نود أن
          نطلب منك في بداية العلاج تحديد شخص مقرب نستطيع التواصل معه في حالات الطوارئ.
        </li>
      </ul>
      <p>
        يمكن العثور على معلومات حول عرض الإرشاد النفسي في برنامج „علاج نفسي“
        <a :href="url" target="_blank" rel="noopener noreferrer">هنا</a>
      </p>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  computed: {
    url() {
      return this.$router.resolve({ name: 'conditionsCounseling' }).href
    },
  },
})
</script>

<style></style>
